import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";

export default function NotFound() {
  const mainColor = "#CC6323";
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate((prev) => !prev);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    
      }}
    >
      <Box sx={{ textAlign: "center", display: "inline-block" }}>
        <Typography
          variant="h1"
          fontWeight={800}
          sx={{ color: mainColor, fontSize: { xs: "5rem", md: "7rem" }, mb: 2 }}
        >
          404
        </Typography>

        <Typography variant="h5" fontWeight={600} gutterBottom>
          Oops — page not found.
        </Typography>

        <Typography variant="body1" color="text.secondary" mb={3}>
          The page you&apos;re looking for doesn&apos;t exist.
        </Typography>

        <Stack direction="row" justifyContent="center" mb={5}>
          <Button
            component={Link}
            to="/"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: mainColor,
              boxShadow: `0 6px 18px rgba(204,99,35,0.24)`,
              textTransform: "none",
              fontWeight: 600,
              ":hover": { backgroundColor: "#b5541e" },
            }}
          >
            Go to Invest Now
          </Button>
        </Stack>

 <Box sx={{ mt: 5, display: "inline-block" }}>
          <svg
            viewBox="0 0 200 200"
            width="200"
            height="200"
            role="img"
            aria-hidden
            style={{ transform: animate ? "rotate(10deg)" : "rotate(-10deg)", transition: "transform 1s ease-in-out" }}
          >
            <defs>
              <linearGradient id="g" x1="0" x2="1">
                <stop offset="0%" stopColor={mainColor} stopOpacity="0.95" />
                <stop offset="100%" stopColor="#FFB89A" stopOpacity="0.9" />
              </linearGradient>
            </defs>

            <rect x="10" y="40" width="180" height="110" rx="18" fill="url(#g)" opacity="0.95" />
            <circle cx="60" cy="90" r="18" fill="#fff" opacity="0.95" />
            <circle cx="140" cy="90" r="18" fill="#fff" opacity="0.95" />
            <path d="M60 120 Q100 155 140 120" stroke="#fff" strokeWidth="6" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.95" />
            <g transform="translate(100 32)">
              <rect x="-10" y="-10" width="20" height="20" rx="4" fill={mainColor} opacity="0.95" />
            </g>
          </svg>
        </Box>




      </Box>
    </Box>
  );
}